import React, { useState, useEffect } from 'react';
import { DocumentsServices } from '../../services';
import { FileList } from '../../components';

function Condicoes() {
  const [news, setNews] = useState([]);
  useEffect(() => {
    async function fetchNews() {
      try {
        const response = await DocumentsServices.fetchDocuments('news');
        setNews(response.data);
      } catch (error) {
        console.log(error);
      }
    }

    fetchNews();
  }, []);
  return (
    <>
      <h1>Notícias</h1>
      <p>Últimas notícias da cooperativa.</p>
      <FileList  files={news || []} />
    </>
  )
}

export default Condicoes;